/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".isSticky_8df49049{position:fixed;-webkit-overflow-scrolling:touch;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}\n"}]);
export const isSticky = "isSticky_8df49049";